import React, { Component } from "react";
import * as Icon from "react-feather";

import "./tools-callout.css";

class ToolsCallout extends Component {
	render() {
		const { icon, tone = "accent", title, description, actionLabel, onClick } = this.props;

		const iconClass = "tools-callout__icon tools-callout__icon--" + tone;

		return (
			<button type="button" className="tools-callout" onClick={onClick}>
				<span className={iconClass}>{icon}</span>
				<span className="tools-callout__text">
					<span className="tools-callout__title">{title}</span>
					{description && <span className="tools-callout__sub">{description}</span>}
				</span>
				{actionLabel && (
					<span className="tools-callout__action">
						{actionLabel}
						<Icon.ChevronRight size={16} />
					</span>
				)}
			</button>
		);
	}
}

export default ToolsCallout;
